<template>
    <div>
        <div v-if="mode==='pc'">
            <PcLaboratory></PcLaboratory>
        </div>
        <div v-if="mode==='mobile'">
            <MobileLaboratory></MobileLaboratory>
        </div>
    </div>
</template>

<script>
    import PcLaboratory from '@/components/pc/PCLaboratory'
    import MobileLaboratory from '@/components/mobile/mobileLaboratory'
    export default {
        components:{
            PcLaboratory,
            MobileLaboratory
        },
        computed:{
            mode(){
                return this.$store.state.mode;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/pages/laboratory.vue